import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

export const orderNumberStyles: SearchTextFieldStyles = {};
const styles = orderNumberStyles;

const OrderHistorySearchFieldRequisitionNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField={"requisitionNumber" as keyof GetOrdersApiParameter}
            label="Requisition #"
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterOrderNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldRequisitionNumber,
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Requisition Number",
    },
};

export default widgetModule;
